<!--
 * @Author: your name
 * @Date: 2020-10-09 17:49:33
 * @LastEditTime: 2021-03-23 16:18:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\views\Home\Member\children\Operation.vue
-->
<template>
  <div id='operation'>
    <el-row class="header">
      <el-col :xs="2" :sm="2" :md="2" :lg="4" :xl="2" class="title">
        <img src="@/assets/img/操作日志.png" alt="">操作记录
      </el-col>
    </el-row>
    <el-table :data="mineData" stripe style="width: 100%">
      <el-table-column prop="createTime">
        <template slot="header" slot-scope="scope">
          操作时间
          <el-popover popper-class="admin_mineOpa" placement="bottom" width="200" trigger="click">
            <el-date-picker class="mineOpa_picker" v-model="tableParams.mineTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime">
            </el-date-picker>
            <i slot="reference" class="el-icon-caret-bottom arrow"></i>
          </el-popover>
          <img class="sort" :class={rotate:isRotate} src="@/assets/img/sort.png" alt="" @click="mineHandleImg">
        </template>
        <template slot-scope="scope">
          {{$dayjs(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss")}}
        </template>
      </el-table-column>
      <el-table-column prop="ipAddress" label="IP地址">
        <template slot-scope="scope">
          {{scope.row.ipAddress==''||scope.row.ipAddress==undefined||scope.row.ipAddress==null?'/':scope.row.ipAddress}}
        </template>
      </el-table-column>
      <el-table-column prop="loginAddress" label="登录地点">
        <template slot-scope="scope">
          {{scope.row.loginAddress==''||scope.row.loginAddress==undefined||scope.row.loginAddress==null?'/':scope.row.loginAddress}}
        </template>
      </el-table-column>
      <el-table-column prop="theme" label="针对主体">
        <!-- <template slot="header" slot-scope="scope">
          针对主体
          <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
            <el-input clearable placeholder="请输入针对主体" v-model="tableParams.memberUnitName" @change="init">
              <img slot="prefix" src="@/assets/img/search.png" alt="">
            </el-input>
            <i slot="reference" class="el-icon-caret-bottom arrow"></i>
          </el-popover>
        </template> -->
        <template slot-scope="scope">
          {{scope.row.theme==''||scope.row.theme==undefined||scope.row.theme==null?'/':scope.row.theme}}
        </template>
      </el-table-column>
      <el-table-column prop="operation" label="操作">
        <!-- <template slot="header" slot-scope="scope">
          操作
          <el-popover popper-class="member_code" placement="bottom" width="100" trigger="click">
            <el-input clearable placeholder="请输入操作" v-model="tableParams.operationName" @change="init">
              <img slot="prefix" src="@/assets/img/search.png" alt="">
            </el-input>
            <i slot="reference" class="el-icon-caret-bottom arrow"></i>
          </el-popover>
        </template> -->
      </el-table-column>
    </el-table>
    <el-pagination class="two" @current-change="mineCurrentChange" :current-page.sync="tableParams.pageNumber" :page-size="tableParams.pageSize" layout="total, prev, pager, next" :total="mineTotalPage">
    </el-pagination>
  </div>
</template>
<script>
import { getLogList } from '@/api/index'
export default {
  data() {
    return {
      mineData: [],
      tableParams: {
        pageNumber: 1,
        pageSize: 10,
        operationType: 1,  // 1本2下
        mineTime: [],
        startTimeStr: '',
        endTimeStr: '',
        operationName: '',
        memberUnitName: '',
        sort: '',
        userName: '',
        companyName: ''
      },
      mineTotalPage: 0,
      isRotate: true,
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      if (this.isRotate) {
        this.tableParams.sort = 'desc'
      } else {
        this.tableParams.sort = 'asc'
      }
      const { data } = await getLogList(this.tableParams)
      if (data.code != 0) return
      this.mineData = JSON.parse(JSON.stringify(data.recordDtoList))
      this.mineTotalPage = data.total
    },
    mineHandleImg() {
      this.isRotate = !this.isRotate
      this.init()
    },
    changeTime(time) {
      if (time == null) {
        this.tableParams.mineTime = []
        this.tableParams.startTimeStr = ''
        this.tableParams.endTimeStr = ''
      } else {
        this.tableParams.mineTime = time
        this.tableParams.startTimeStr = time[0]
        this.tableParams.endTimeStr = time[1]
      }
      this.init()
    },
    mineCurrentChange(page) {
      this.tableParams.pageNumber = page
      this.init()
    },
  }
}
</script>
<style lang='less' scoped>
#operation {
  padding: 0 25px;
  .header {
    font-size: 18px;
    margin-bottom: 20px;
    img {
      width: 23px;
      margin-right: 15px;
      vertical-align: bottom;
    }
  }
}
</style>